import {
  onUnmounted,
} from 'vue';
import { storeToRefs } from 'pinia';
import { useAnnotationTypeStore } from '@/stores/useAnnotationTypeStore.js';

export default function useAnnotationType() {
  const {
    selectedDisplayTypes,
    jsonViewerShowTypes,
  } = storeToRefs(useAnnotationTypeStore());

  const {
    $reset,
  } = useAnnotationTypeStore();

  onUnmounted(() => {
    $reset();
  });

  const ALL_TYPES = [
    {
      key: 'pcd',
      display: 'Radar Point Cloud',
    },
    {
      key: 'imu',
      display: 'Pose',
    },
    {
      key: 'gps',
      display: 'Location',
    },
    {
      key: 'radar',
      display: 'Radar',
    },
    {
      key: 'lidar',
      display: 'LiDAR Point Cloud',
    },
    {
      key: 'box',
      display: '2D Bounding Box',
    },
    {
      key: '3dbox',
      display: '3D Bounding Box',
    },
    {
      key: 'seg',
      display: '2D Polygon',
    },
    {
      key: 'mask',
      display: 'Mask File',
    },
    {
      key: 'scales',
      display: 'Scales File',
    },
    {
      key: 'cube',
      display: 'Cube File',
    },
    {
      key: 'depthmap',
      display: 'Depth Map',
    },
  ];

  function getTypeDisplayString(str) {
    let result = "";
    switch (str) {
    case 'pcd':
      result = "Point Cloud Data";
      break;
    case 'radar':
      result = "Radar";
      break;
    case 'gps':
      result = "Location";
      break;
    case 'imu':
      result = "Pose";
      break;
    case 'box':
      result = "2D Bounding Box";
      break;
    case 'seg':
      result = "2D Polygon";
      break;
    case 'mask':
      result = "Mask File";
      break;
    case '3dbox':
      result = "3D Bounding Box";
      break;
    case 'cube':
      result = "Cube File";
      break;
    case 'scales':
      result = "Scales File";
      break;
    case 'depthmap':
      result = "Depth Map";
      break;
    default:
      result = str;
      break;
    }
    return result;
  }

  return {
    getTypeDisplayString,
    ALL_TYPES,
    jsonViewerShowTypes,
    selectedDisplayTypes,
  };
}
